<script setup lang="ts">
import type { NovaFormContainerProps } from './NovaFormContainer.types'

defineProps<NovaFormContainerProps>()
</script>

<template>
  <div class="form-container">
    <div v-if="title || guide" class="header">
      <h4 v-dompurify-html="title" class="title" />
      <p v-dompurify-html="guide" class="guide" />
    </div>

    <div class="body">
      <slot name="default"></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form-container {
  display: flex;
  flex-direction: column;
  gap: 6px;

  > .header {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .title {
      flex-grow: 1;
      @include text-style($text-body-14-bold);
      color: $color-text-1;
    }

    .guide {
      @include text-style($text-body-12-regular);
      color: $color-text-2;
    }
  }
}
</style>
